import React, { useEffect, useState } from "react";

const NewsManagement = () => {
  const [newsList, setNewsList] = useState([]);
  const [titleEn, setTitleEn] = useState("");
  const [titleFr, setTitleFr] = useState("");
  const [titleDe, setTitleDe] = useState("");
  const [titleIt, setTitleIt] = useState("");
  const [titleEs, setTitleEs] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    fetch("/api/news")
      .then((response) => response.json())
      .then((data) => setNewsList(data))
      .catch((error) => console.error("Error fetching news:", error));
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    fetch("/api/news", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title_en: titleEn,
        title_fr: titleFr,
        title_de: titleDe,
        title_it: titleIt,
        title_es: titleEs,
      }),
    })
      .then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json();
          setErrorMessage(errorData.detail);
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setNewsList([...newsList, data]);
        setTitleEn("");
        setTitleFr("");
        setTitleDe("");
        setTitleIt("");
        setTitleEs("");
        setErrorMessage("");
      })
      .catch((error) => {
        setErrorMessage("Failed to create news: " + error.message);
      });
  };

  return (
    <div className="p-4">
      <button
        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mb-4"
        type="button"
        onClick={() => (window.location.href = "/admin/dashboard")}
      >
        Go Back
      </button>
      <table className="min-w-full border border-gray-200">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b">Title</th>
          </tr>
        </thead>
        <tbody id="news-container">
          {newsList.map((news) => (
            <tr
              key={news.id}
              className="hover:bg-gray-950 cursor-pointer"
              onClick={() => (window.location.href = `/admin/news/${news.id}`)}
            >
              <td className="py-2 px-4 border-b">{news.title}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <form id="news-creation-form" onSubmit={handleSubmit} className="mt-4">
        <div className="mb-4">
          <label htmlFor="news-title-en" className="block">
            Title (English):
          </label>
          <input
            type="text"
            id="news-title-en"
            name="title_en"
            value={titleEn}
            onChange={(e) => setTitleEn(e.target.value)}
            required
            className="mt-1 p-2 border border-gray-300 rounded w-full text-gray-800"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="news-title-fr" className="block">
            Title (French):
          </label>
          <input
            type="text"
            id="news-title-fr"
            name="title_fr"
            value={titleFr}
            onChange={(e) => setTitleFr(e.target.value)}
            required
            className="mt-1 p-2 border border-gray-300 rounded w-full text-gray-800"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="news-title-de" className="block">
            Title (German):
          </label>
          <input
            type="text"
            id="news-title-de"
            name="title_de"
            value={titleDe}
            onChange={(e) => setTitleDe(e.target.value)}
            required
            className="mt-1 p-2 border border-gray-300 rounded w-full text-gray-800"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="news-title-it" className="block">
            Title (Italian):
          </label>
          <input
            type="text"
            id="news-title-it"
            name="title_it"
            value={titleIt}
            onChange={(e) => setTitleIt(e.target.value)}
            required
            className="mt-1 p-2 border border-gray-300 rounded w-full text-gray-800"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="news-title-es" className="block">
            Title (Spanish):
          </label>
          <input
            type="text"
            id="news-title-es"
            name="title_es"
            value={titleEs}
            onChange={(e) => setTitleEs(e.target.value)}
            required
            className="mt-1 p-2 border border-gray-300 rounded w-full text-gray-800"
          />
        </div>
        <div
          className="error-message text-red-500 mb-4"
          id="news-creation-error"
        >
          {errorMessage}
        </div>
        <button
          type="submit"
          className="text-white py-2 px-4 rounded hover:bg-blue-700 bg-blue-600"
        >
          Create News
        </button>
      </form>
    </div>
  );
};

export default NewsManagement;
